// Auto-generated by scripts/update-version.js — DO NOT EDIT MANUALLY
export const BUILD_NUMBER = 1793794913;
export const GIT_HASH = "686441d";
